






import { Component, Vue, Prop } from 'vue-property-decorator';
import { debounce } from 'lodash-es';
import { algoliaClient } from '@/algolia';
import algoliasearch from 'algoliasearch';
import { VueAutosuggest } from 'vue-autosuggest';

@Component({
  components: {
    VueAutosuggest
  }
})
export default class AutocompleteInput extends Vue {
  @Prop() collectionName!: string;
  @Prop() facetName!: string;
  @Prop({ default: 'Type to search' })
  placeholder!: string;

  protected algoliaIndex: algoliasearch.Index;
  protected options: any[] = [{ data: [] }];
  protected selected: string = '';
  protected inputProps: any = {
    id: 'autosuggest__input',
    onInputChange: debounce(this.onInputChange, 300),
    placeholder: this.placeholder
  };

  constructor(props: any) {
    super(props);
    const projectID = process.env.VUE_APP_FIREBASE_PROJECTID;
    this.algoliaIndex = algoliaClient.initIndex(
      `${projectID}_${this.collectionName}`
    );
    this.algoliaIndex.setSettings({
      attributesForFaceting: ['searchable(' + this.facetName + ')']
    });
  }

  onInputChange(text: string) {
    this.selected = text;
    this.emitInputText();
    this.algoliaIndex
      .searchForFacetValues({
        facetName: this.facetName,
        facetQuery: text,
        sortFacetValuesBy: 'alpha'
      })
      .then(resp => {
        const data = resp.facetHits.map(result => {
          return result.value;
        });
        this.options = this.options.map(option => Object.assign({}, { data }));
      })
      .catch(err => {
        console.error(err);
        this.$options[0].data = [];
      });
  }

  onSelected(option: any) {
    this.selected = option.item;
    this.emitInputText();
  }

  // reset value on autosuggest
  resetValue() {
    let refVueAutosuggest = this.$refs.setValue as VueAutosuggest;
    refVueAutosuggest.searchInput = '';
  }

  emitInputText() {
    this.$emit('input-text', this.selected);
  }
}
